/* eslint-disable max-len */
// Dependencies
import React from 'react'
import {connect} from 'react-redux'

// import Helpers from '../Helpers.js'

// Images

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import PdfRender from './PdfRender'
import ImageRender from './ImageRender'
import DefaultFileRender from './DefaultFileRender'
import VideoRender from './VideoRender'
import AudioRender from './AudioRender'
// import stylesFileRender from '../styles/FileRender.module.css'

// Components

function FileRender(props) {
  return (
    <>
      {props?.file?.type?.includes('video/') ?
        <VideoRender file={props.file} /> :
        props?.file?.type?.includes('audio/') ?
        <AudioRender file={props.file} /> :
        props?.file?.type?.includes('pdf') ?
        <PdfRender file={props.file} /> :
        props?.file?.type?.includes('image') ?
        <ImageRender file={props.file}/> :
        <DefaultFileRender file={props.file} />
      }
    </>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
})

export default connect(
    mapStateToProps,
    {},
)(FileRender)
